import React, {
  useState,
  useLayoutEffect,
  useEffect,
  useRef,
  useContext,
} from "react";
import img from "../../src/assests/Images/formPage.png";
import { useLocation, useNavigate } from "react-router-dom";
import pdf2pagefoot from "../assests/pdf2pagefoot.png";

import BoxSVG from "../SVGs/box/box";
import BagSVG from "../SVGs/bag/bags";
import StickerSVG from "../SVGs/sticker/sticker";
import TissueSVG from "../SVGs/tissue/tissue";
import ReceiptSVG from "../SVGs/receipt/receiptOutside";
import ReceiptSVGInside from "../SVGs/receipt/receiptInside";

import { toPng } from "html-to-image";
import { PDFDocument, rgb } from "pdf-lib";
import Swal from "sweetalert2";
import background from "../../src/assests/backgroundPDF.png";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import { GlobalStateContext } from "../App";

export default function Form({ setToken }) {
  const firstName = useRef(null);
  const surName = useRef(null);
  const email = useRef(null);
  const phone = useRef(null);
  const companyName = useRef(null);
  const time = useRef(null);
  const heardFrom = useRef(null);
  const isLoading = useRef(false);
  const password = useRef(null);

  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const userData = globalState?.userData;
  const [pdf, setPDF] = useState(null);
  const [pdfBackground, setPdfBackground] = useState();
  const [loading, setLoding] = useState(null);
  const navigate = useNavigate();

  const state =
    useLocation().state || JSON.parse(localStorage.getItem("state"));

  const convertToPdfBase64 = async ([page1, page1Ele], [page2, page2Ele]) => {
    const pdfDoc = await PDFDocument.create();
    const firstPage = pdfDoc.addPage([
      page1Ele.offsetWidth,
      page1Ele.offsetHeight,
    ]);
    const firstPageImage = await pdfDoc.embedPng(page1);

    const secondPage = pdfDoc.addPage([
      page2Ele.offsetWidth,
      page2Ele.offsetHeight,
    ]);
    const secondPageImage = await pdfDoc.embedPng(page2);

    firstPage.drawImage(firstPageImage, {
      x: 0,
      y: 0,
      width: page1Ele.offsetWidth,
      height: page1Ele.offsetHeight,
      opacity: 1,
    });

    secondPage.drawImage(secondPageImage, {
      x: 0,
      y: 0,
      width: page2Ele.offsetWidth,
      height: page2Ele.offsetHeight,
      opacity: 1,
    });

    const pdfBytes = await pdfDoc.save();
    let binaryString = "";
    for (let i = 0; i < pdfBytes.length; i++) {
      binaryString += String.fromCharCode(pdfBytes[i]);
    }
    const pdfBase64 = btoa(binaryString);
    return pdfBase64;
  };

  const handleSubmit = (pdf) => {
    console.log(pdf);
    const formData = {
      emailContent: "Here are your packaging design concept details:",
      emailSubject: "Your Packaging Collection Concept",
      firstName: firstName.current.value,
      surName: surName.current.value,
      customerEmail: userData 
        ? email.current.value
        : globalState?.userData?.email || localStorage.getItem("rgs_email"),
      phone: phone.current.value,
      company: companyName.current.value,
      time: selected2,
      heardFrom: selected,
      state: state,
      pdf: pdf,
    };
    console.log(formData);

    const sendEmail = (userEmails) => {
      const emails = userEmails.split(",").concat(formData.customerEmail);
      emails.forEach((userEmail) => {
        const emailData = { ...formData, userEmail };
        // Create a new FormData object to send the form data
        const data = new FormData();
        for (const key in emailData) {
          //data.append('heardFrom',pdfFile);
          data.append(key, formData[key]);
        }
        fetch("https://parifypackaging.co.uk/Staging/email.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(emailData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    };

    sendEmail("meherpappur@gmail.com , meherpappur@gmail.com");
  };

  const submitAndDownload = async () => {
    const loadingButton = document.getElementById("loadingButton");
    const downloadButton = document.getElementById("downloadButton");

    const tests = [
      firstNameHandler(),
      surNameHandler(),
      userData && eMailHandler(),
      phoneNoHandler(),
      companyNameHandler(),
      //timeHandler(),
      //heardFromHandler(),
    ];
    const isPassed = !tests.includes(false);

    if (isPassed) {
      loadingButton.style.display = "block"; // Show loading content
      downloadButton.style.display = "none"; // Hide download content

      const page1Ele = document.getElementById("page1");
      const page2Ele = document.getElementById("page2");

      try {
        const page1 = await toPng(page1Ele, { cacheBust: false });
        const page2 = await toPng(page2Ele, { cacheBust: false });

        convertToPdfBase64([page1, page1Ele], [page2, page2Ele])
          .then((pdfBase64) => {
            handleSubmit(pdfBase64);
            setPDF(pdfBase64);
            //navigate("/sent-page");
          })
          .catch((err) => {
            console.log("Error converting to PDF:", err);
          });
      } catch (err) {
        console.log({ err });
      }
    }
  };

  useEffect(() => {
    const download = document.getElementById("downloadPDF");
    if (pdf != null) {
      download.click();
      navigate("/sent-page");
      //setLoding("done")
    }
  }, [pdf]);

  const PDF = () => {
    return (
      <>
        <section
          id="page1"
          style={{
            position: "relative",
            width: "1300px",
            height: "900px",
            backgroundColor: "#fff",
          }}
        >
          <img src={background} alt="backgroundPDF" />
          <div
            style={{
              position: "absolute",
              bottom: "100px",
              right: "90px",
              width: "380px",
              aspectRatio: "1/1",
              zIndex: "10",
            }}
          >
            <BoxSVG
              logo={state[0].logo}
              innerColor={state[0].innerColor}
              boxColor={state[0].boxColor}
              logoSize={state[0].logoSize}
              pdf={true}
            />
          </div>
          <div
            style={{
              position: "absolute",
              top: "-60px",
              right: "-20px",
              width: "770px",
              aspectRatio: "1/1",
            }}
          >
            <BagSVG
              logo={state[1].logo}
              bagColor={state[1].bagColor}
              handleColor={state[1].handleColor}
              gussetColor={state[1].gussetColor}
              logoSize={state[1].logoSize}
            />
          </div>
          <div
            style={{
              position: "absolute",
              top: "-52px",
              left: "25px",
              width: "700px",
              aspectRatio: "1/1",
            }}
          >
            <TissueSVG
              t1Logo={state[2].t1Logo}
              t2Logo={state[2].t2Logo}
              t1Color={state[2].t1Color}
              t2Color={state[2].t2Color}
            />
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "110px",
              left: "11px",
              width: "420px",
              aspectRatio: "1/1",
            }}
          >
            <StickerSVG
              logo={state[3].logo}
              color={state[3].color}
              pdf={true}
            />
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "106px",
              left: "245px",
              width: "277px",
              aspectRatio: "1/1",
            }}
          >
            <ReceiptSVG
              logo={state[4].logo}
              urlLink={state[4].urlLink}
              pdf={true}
              logoSize={state[4].logoSize}
            />
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "47px",
              left: "420px",
              width: "370px",
              aspectRatio: "1/1",
            }}
          >
            <ReceiptSVGInside
              flipColor={state[5].flipColor}
              introText={state[5].introText}
              rhsBG={state[5].rhsBG}
              pdf={true}
            />
          </div>
        </section>
        <section
          id="page2"
          style={{
            position: "relative",
            width: "1300px",
            backgroundColor: "#fff",
            paddingBottom: "100px",
          }}
        >
          <p
            className="p-10"
            dangerouslySetInnerHTML={{
              __html: `
          <h1 class="text-2xl px-3 text-center">* Your Design Specifications * </h1> <br/>
          <br/>LUXURY RING BOX <br/>
            - logoSize: ${state[0].logoSize} <br/>
            - innerColour: ${state[0].innerColor} <br/>
            - boxColour: ${state[0].boxColor} <br/>
          
          <br/>LUXURY GIFT BAGS <br/>
            - logoSize: ${state[1]?.logoSize} <br/>
            - handleColour: ${state[1]?.handleColor} <br/>
            - gussetColour: ${state[1]?.gussetColor} <br/>
            - bagColour: ${state[1]?.bagColor} <br/>
          
          <br/>TISSUE PAPER <br/>
            - t1LogoSize: ${state[2]?.t1LogoSize} <br/>
            - t2LogoSize: ${state[2]?.t2LogoSize} <br/>
            - t1Colour: ${state[2]?.t1Color} <br/>
            - t2Colour: ${state[2]?.t2Color} <br/>
          
          <br/>STICKERS <br/>
            - logoSize: ${state[3]?.logoSize} <br/>
            - colour: ${state[3]?.color} <br/>
          
          <br/>RECEIPT WALLET (COVER) <br/>
            - logoSize: ${state[4]?.logoSize} <br/>
            - urlLink: ${state[4]?.urlLink} <br/>
          
          <br/>RECEIPT WALLET (INSIDE) <br/>
            - flipColour: ${state[5]?.flipColor} <br/>
            - introText: ${state[5]?.introText} <br/>
          `,
            }}
          ></p>

          <img
            style={{
              position: "absolute",
              bottom: "0",
              right: "0",
              width: "100%",
              zIndex: "10",
            }}
            src={pdf2pagefoot}
          />
        </section>
      </>
    );
  };

  function firstNameHandler() {
    const name = firstName.current.value;
    if (name.length == 0) {
      firstName.current.style.border = "1px solid red";
      firstName.current.placeholder = "First Name is Required*";
      return false;
    }
    firstName.current.style.border = "1px solid rgb(209 213 219)";
    return true;
  }

  function surNameHandler() {
    const name = surName.current.value;
    if (name.length == 0) {
      surName.current.style.border = "1px solid red";
      surName.current.placeholder = "Surname is Required*";
      return false;
    }
    surName.current.style.border = "1px solid rgb(209 213 219)";
    return true;
  }

  function eMailHandler() {
    const regex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (email.current.value.match(regex)) {
      email.current.style.border = "1px solid rgb(209 213 219)";
      return true;
    } else {
      email.current.style.border = "1px solid red";
      email.current.placeholder = "Valid Email is Required*";
      return false;
    }
  }

  function phoneNoHandler() {
    const no = phone.current.value;
    if (no.length == 0) {
      phone.current.style.border = "1px solid red";
      phone.current.placeholder = "Phone No is Required*";
      return false;
    }
    phone.current.style.border = "1px solid rgb(209 213 219)";
    return true;
  }

  function companyNameHandler() {
    const name = companyName.current.value;
    if (name.length == 0) {
      companyName.current.style.border = "1px solid red";
      companyName.current.placeholder = "Company Name is Required*";
      return false;
    }
    companyName.current.style.border = "1px solid rgb(209 213 219)";
    return true;
  }

  const option1 = [
    { title: "YouTube" },
    { title: "Google" },
    { title: "Email" },
    { title: "Online (Website)" },
    { title: "Trade Event" },
    { title: "Trade Magazine" },
    { title: "Word of Mouth" },
  ];
  const option2 = [{ title: "Yes" }, { title: "No" }];

  const [isActive, setIsActive] = useState(false);
  const [selected, setIsSelected] = useState("How did you hear about us?");
  const [isActive2, setIsActive2] = useState(false);
  const [selected2, setIsSelected2] = useState("Request a call back");

  return (
    <>
      <section className="my-[150px] min-h-[600px] relative">
        <div className="absolute rounded-[10px] w-[80vw] lg:w-[800px] h-[100%] left-[50%] translate-x-[-50%] bg-[#fff] drop-shadow p-[20px] md:p-[50px] lg:p-[100px] flex flex-col justify-center items-center gap-5">
          <h1
            className="text-center font-semibold text-[24px]"
            style={{ fontFamily: "ZapfHumanistBold" }}
          >
            Almost There…
          </h1>
          <p className="text-center text-[14px]">
            Simply complete the fields below to download a PDF of your designs.{" "}
          </p>

          <form>
            <input
              className="w-[calc(50%-5px)] mb-[5px] mr-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
              type="text"
              placeholder="First Name"
              ref={firstName}
              onChange={firstNameHandler}
              defaultValue={globalState?.userData?.name}
            />
            <input
              className="w-[calc(50%-5px)] mb-[5px] ml-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
              type="text"
              placeholder="Surname"
              ref={surName}
              onChange={surNameHandler}
            />
            {userData ? (
              <input
                className="w-[calc(50%-5px)] my-[5px] mr-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                type="email"
                placeholder="Email"
                ref={email}
                onChange={eMailHandler}
                defaultValue={
                  globalState?.userData?.email ||
                  localStorage.getItem("rgs_email") ||
                  ""
                }
              />
            ) : (
              <input
                className="w-[calc(50%-5px)] my-[5px] mr-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                type="password"
                placeholder="Password"
                ref={password}
              />
            )}
            <input
              className="w-[calc(50%-5px)] mt-[5px] mb-[10px] ml-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
              type="tel"
              placeholder="Phone"
              ref={phone}
              onChange={phoneNoHandler}
              defaultValue={globalState?.userData?.phone}
            />
            <input
              className="w-[calc(50%-5px)] my-[5px] mr-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
              type="text"
              placeholder="Company Name"
              ref={companyName}
              onChange={companyNameHandler}
            />
            <div className="relative inline-block w-[calc(50%-5px)] ml-[4px] text-gray-900">
              <div
                onClick={() => {
                  setIsActive2(!isActive2);
                }}
                className="w-[100%] my-[5px] mr-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 flex flex-row items-center justify-between"
              >
                <p className="text-[#9FA6B2]">{selected2}</p>
                <span>
                  <AiOutlineDown />
                </span>
              </div>
              <div
                className={`dropdown-content h-[50px] ${
                  isActive2 ? "block" : "hidden"
                } absolute z-10 bg-white border border-gray-300 mt-2 rounded-lg shadow-lg w-[calc(50%-5px)] text-gray-900`}
              >
                {option2.map((value, index) => (
                  <div
                    onClick={() => {
                      setIsSelected2(value.title);
                      setIsActive2(false);
                    }}
                    key={index}
                    className="py-2 px-4 cursor-pointer hover:bg-gray-100 "
                  >
                    {value.title}
                  </div>
                ))}
              </div>
            </div>
            <div className="relative inline-block w-full">
              <div
                onClick={() => {
                  setIsActive(!isActive);
                }}
                className="w-[100%] my-[5px] mr-[5px] float-left bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 flex flex-row items-center justify-between"
              >
                <p className="text-[#9FA6B2]">{selected}</p>
                <span>
                  <AiOutlineDown />
                </span>
              </div>
              <div
                className={`dropdown-content ${
                  isActive ? "block" : "hidden"
                } absolute z-10 bg-white border border-gray-300 mt-2 rounded-lg shadow-lg`}
              >
                {option1.map((value, index) => (
                  <div
                    onClick={() => {
                      setIsSelected(value.title);
                      setIsActive(false);
                    }}
                    key={index}
                    className="py-2 px-4 cursor-pointer hover:bg-gray-100"
                  >
                    {value.title}
                  </div>
                ))}
              </div>
            </div>
          </form>
          <button
            style={{ fontFamily: "ZapfHumanistBold" }}
            className="py-2 px-4 rounded-full  bg-red-500 hover:bg-[#02595A] text-white mt-4 text-[14px]"
            onClick={submitAndDownload}
            ref={isLoading}
            id="downloadButton"
          >
            SEND ME MY DESIGN
          </button>
          <button
            className="py-2 px-4 rounded-full  bg-black text-white mt-4 hidden"
            ref={isLoading}
            id="loadingButton"
          >
            Loading...
          </button>
          <div className="">
            <img className="w-[1000px] mt-3.5" src={img} alt="logo"></img>
          </div>
        </div>
      </section>
      <section
        style={{
          position: "absolute",
          top: "-1000px",
          transform: "rotateX(90deg)",
        }}
      >
        <PDF />
      </section>
      {/* Display the PDF */}
      {pdf && (
        <a
          id="downloadPDF"
          href={"data:application/pdf;base64," + pdf}
          download={`Your_Packaging_Suite_Concepts.pdf`}
        ></a>
      )}
    </>
  );
}